// File: src/App.js (FINAL CORRECTED VERSION)

import React from 'react';
// FIX: Remove BrowserRouter from this file
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// --- Import Your Pages ---
import Home from './pages/Home';
import PendingApprovalPage from './pages/PendingApprovalPage';
import RoleBasedDashboard from './pages/RoleBasedDashboard';
import StaffApplication from './pages/StaffApplication';

// --- Import Your Protected Route Component ---
import ProtectedRoute from './components/ProtectedRoute';

// --- Define your dashboard component ---
const Dashboard = () => <RoleBasedDashboard />;

// --- Main App Component ---
export default function App() {
  const { userProfile, loading, settingsLoading } = useAuth();

  if (loading || settingsLoading) {
      return (
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <p className="text-lg font-semibold text-indigo-600">Initializing Portal...</p>
          </div>
      );
  }

  // FIX: Removed the <BrowserRouter> wrapper from this file.
  // It is now correctly placed in src/index.js.
  return (
        <Routes>
            {/* === PUBLIC ROUTES === */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="/apply/staff" element={<StaffApplication />} />

            {/* === LOGGED-IN ONLY ROUTES === */}
            <Route
                path="/pending-approval"
                element={
                    userProfile ?
                        (userProfile.status === 'pending_approval' ?
                            <PendingApprovalPage />
                            : <Navigate to={`/${userProfile.role}/dashboard`} replace />)
                        : <Navigate to="/" replace />
                }
            />

            {/* === ROLE-PROTECTED DASHBOARDS === */}
            <Route path="/student/dashboard" element={ <ProtectedRoute role="student"><Dashboard /></ProtectedRoute> } />
            <Route path="/guest/dashboard" element={ <ProtectedRoute role="guest"><Dashboard /></ProtectedRoute> } />
            <Route path="/educator/dashboard" element={ <ProtectedRoute role="educator"><Dashboard /></ProtectedRoute> } />
            <Route path="/examiner/dashboard" element={ <ProtectedRoute role="examiner"><Dashboard /></ProtectedRoute> } />
            <Route path="/exam_admin/dashboard" element={ <ProtectedRoute role="exam_admin"><Dashboard /></ProtectedRoute> } />
            <Route path="/admin/dashboard" element={ <ProtectedRoute role="admin"><Dashboard /></ProtectedRoute> } />
            <Route path="/owner/dashboard" element={ <ProtectedRoute role="owner"><Dashboard /></ProtectedRoute> } />

            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
  );
}
